module.exports = __webpack_public_path__ + "img/payment-method-icon.6916526e.svg";